import { Component, OnInit, Type } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe, DecimalPipe } from "@angular/common";
import { SWAlertService } from "../../services/swalert.service";
import { BusinessDayService } from "../../services/business-day.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker/public_api";
import { isNullOrUndefined } from "util";
import { TSFuntionService } from "../../services/ts-funtion.service";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/ngx-bootstrap-typeahead";
declare var Uploadfiles, Clearuploadfile, SetData, _Path, Extension: any, Accept: any;
declare var ArrFile: any[];
@Component({
  selector: "app-receiptvoucher",
  templateUrl: "./receiptvoucher.component.html",
  styleUrls: ["./receiptvoucher.component.css"],
  providers: [DatePipe, TSFuntionService, DecimalPipe],
})
export class ReceiptVoucherComponent implements OnInit {
  VendorCodemaxLength: any = 40;
  EditInvoiceCode: any;
  EditInvoiceDate: any;
  ResultPermission: boolean;
  TypeNoResult: any;
  CopyNoResult: any;
  GlNoResult: any[] = [];
  CostCenterNoResult: any[] = [];
  IONoResult: any[] = [];
  ProfitCenterNoResult: any[] = [];
  Approve1NoResult: any;
  Approve2NoResult: any;
  isCountryNoResult: any = false;
  sAmphorNoResult: any = false;
  sTumbonNoResult: any = false;
  sSubDistrictNoResult: any = false;
  clicked: boolean  = false;
  nReqUrgentDay: any = 0;
  isDraft: boolean = false;
  isNew: boolean = true;
  isSubmit: boolean = false;
  sReqID: any;
  sReqCode: any;
  haveRequestCode: boolean = false;
  haveComments: boolean = true;
  sComment: string = "";
  sCommentSSC: string = "";
  ArrTransactionHistory: Array<any> = [];
  IsReqUrgent: boolean = false;
  nEditIndex: any;
  isEdit1: boolean;
  isEdit2: boolean;
  isPrint: boolean = false;
  isEditFromhome: boolean = false;
  isThai: boolean;
  bg_color: string = "";
  myFiles: string[] = [];
  sMsg: string = "";
  name: string;
  vendorcode: string;
  sGL: string;
  messagebank: string = " ";
  hBank: boolean;
  hidbankother: boolean;
  DataBankBranch: any;
  masterDataBankBranch: any;
  hBranch: boolean;
  hVatAmount: boolean;
  nComcode: any;
  nCostCenterCode: any;
  sCostcen: any;
  ArrInvoice: Array<any> = [];
  ArrInvoicelength: any;
  ArrMaster: Array<any> = [];
  DataEmployee: any;
  DataRequest: any;
  DataVendor: any = [];
  DataVendorAll: any = [];
  DataGL: any;
  DataCostCenter: any;
  DataIO: any;
  DataProfitCenter: any;
  DataApprover: any;
  DataBusinessArea: any;
  ArrEmployee: any[] = [];
  ArrRequest: any[] = [];
  ArrVendor: any[] = [];
  ArrVendorName: any[] = [];
  ArrIO: any[] = [];
  sArrGL: any[] = [];
  ArrCostCenter: any[] = [];
  ArrProfitCenter: any[] = [];
  ArrApprover: any[] = [];
  GetApprover: any;
  isReject: boolean = false;
  Currency: any;
  Bank: any;
  Currencys: any;
  VatType: any;
  TM_Config: any;
  today: number = Date.now();
  dToday = this.datepipe.transform(this.today, "dd/MM/yyyy");
  maxDate: Date;
  maxDateinvoice: any;
  TODAY: Date;
  toDay: Date;
  Settodate: Date;
  BankNoResult: any;
  todayy: any;
  IsLoadingBankAll: boolean = false;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  holidays: Date[];
  _HolidayDB = [];
  bsConfig: Partial<BsDatepickerConfig>;
  paytovendorForm: FormGroup;
  get _paytovendorForm() {
    return this.paytovendorForm.controls;
  }
  get ArrGL() {
    return this._paytovendorForm.ArrGL as FormArray;
  }
  fileType: any;
  limit: any;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private SW: SWAlertService,
    private BusinessDay: BusinessDayService,
    private _decimalPipe: DecimalPipe,
    private System: TSFuntionService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit() {
    this.System.BlockUI();
    let ua = this.System.GetUserStorage();
    this.nComcode = ua.sCompCode;
    this.ArrMaster[0] = [];
    this.isEdit1 = false;
    this.isEdit2 = false;
    this.maxDate = new Date();
    this.maxDateinvoice = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 1);
    this.TODAY = new Date();
    this.toDay = new Date();
    this.hBranch = true;
    this.hBank = false;
    this.hidbankother = true;

    this.SetForm();
    await this.http
      .get<any>("api/Autocomplete/TM_Holiday/*")
      .toPromise()
      .then((res) => {
        if (res) {
          this._HolidayDB = res.filter(
            (f) => f.IsDelete == false && f.cActive == "Y"
          );
        }
        this.holidays = this._HolidayDB.map(({ dDate }) => new Date(dDate));
      });
    this.bsConfig = Object.assign(
      {},
      {
        containerClass: "theme-dark-blue",
        dateInputFormat: "DD/MM/YYYY",
        showWeekNumbers: false,
        datesDisabled: this.holidays,
        daysDisabled: [0, 6],
      }
    );

    this.today = this.BusinessDay.SetToday(this.holidays).getTime();
    this.dToday = this.datepipe.transform(this.today, "dd/MM/yyyy");
    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.Settodate = this.BusinessDay.SetToday(this.holidays);
    this.TODAY = this.BusinessDay.SetToday(this.holidays);
    this.TODAY.setDate(this.TODAY.getDate() + 1);
    this.TODAY = this.BusinessDay.SetNextDate(this.TODAY, this.holidays);
    this.paytovendorForm.patchValue({
      dDueDate: this.TODAY,
      dChequeDate: this.TODAY,
    });

    await this.GetAutocomplete();
    this.hVatAmount = false;
    this.paytovendorForm.controls["sBranch"].disable();
    this.paytovendorForm.controls["sVendorName"].disable();
    this.paytovendorForm.controls["sTAXID"].disable();
    this.paytovendorForm.controls["sAddress"].disable();
   
    this.activatedRoute.queryParams.subscribe(async () => {
      let ID: string = this.System.GetQuerySTR("str");
      let ID2: string = this.System.GetQuerySTR("ros");
      this.sReqID = await this.System.Decrypt(ID);
      if (ID2 !== "undefined") {
        this.sReqID = await this.System.Decrypt(ID2);
        this.isForROS = true;
      }
      if (this.sReqID === "") {
        this.isNewRequest = true;
      }
      this.Edit(this.sReqID);
    });
    await this.getFileType();
    await this.getFileLimit();
    var setUp = {
      sID: "dvFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limit,
    };
    Uploadfiles(setUp);
    Clearuploadfile();
  }
  checkFile() {
    if (ArrFile.filter((f) => f.IsDelete === false).length > 0) {
      const chkFile = document.getElementById("dv_dvFile");
      chkFile.style.border = "1px solid #dde4f6";
    }
    return "";
  }
  async getFileType() {
    await this.http
      .get(this.System.SiteName + "api/FileConfig/FileType")
      .toPromise()
      .then((data: Response) => {
        const result = [];
        const item = Object.values(data);
        for (let x = 0; x < item.length; x++) {
          if (data[x]["sValue"] === "Y") {
            result.push(data[x]["sValueText"]);
          }
        }
        this.fileType = result;
      });
  }
  async getFileLimit() {
    await this.http
      .get(this.System.SiteName + "api/FileConfig/FileLimit")
      .toPromise()
      .then((data: Response) => {
        const result = [];
        const item = Object.values(data);
        for (let x = 0; x < item.length; x++) {
          result.push(data[x]["sValue"]);
        }
        this.limit = result;
      });
  }
  async Reject() {
    let _this = this;
    let sComment = _this.paytovendorForm.get("sComment").value;
    if (sComment === null || sComment === "") {
      _this.SW.SwAlert.Error(
        _this.SW.BoxMsg.Title_Error,
        _this.SW.BoxMsg.Desc_Specify_Comment,
        undefined
      );
    } else {
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytovendorForm.get("sRequestID").value,
          sComment: sComment,
        },
      };
      let Data = JSON.stringify(DataSave);
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        _this.http
          .post(_this.System.SiteName + "api/ROService/Reject", Data, {
            headers,
            responseType: "text",
          })
          .subscribe((s) => {
            if (s == "Success") {
              ArrFile = [];
              _this.System.UnBlockUI();
              _this.SW.SwAlert.Success(
                _this.SW.BoxMsg.Title_Success,
                _this.SW.BoxMsg.Desc_SaveComplete,
                function () {
                  _this.router.navigate(["ro-service"]);
                }
              );
            } else {
              _this.System.UnBlockUI();
            }
          });
      };
      _this.SW.SwAlert.Confirm(
        _this.SW.BoxMsg.Title_Confirm,
        _this.SW.BoxMsg.Desc_Confirm_Submit,
        save,
        function () {}
      );
    }
  }

  handler(select): void {
    if (select == 1) {
      let Duedate = this.paytovendorForm.value.dDueDate;
      this.paytovendorForm.patchValue({ dDueDate: Duedate });
    }
  }
  async GetAutocomplete() {
    this.IsLoadingBankAll = true;
    await this.http
      .get(this.System.SiteName + "api/Autocomplete/Bank/1/All")
      .toPromise()
      .then((res) => {
        if (res) {
          this.DataBankBranch = res;
          this.IsLoadingBankAll = false;
        }
      });

    this.http
      .get(
        this.System.SiteName +
          "api/Autocomplete/TUserpermission/*/sCompCode/" +
          this.nComcode +
          "/nRole/5"
      )
      .subscribe((data: Response) => {
        this.DataEmployee = data;
        this.ArrEmployee = this.DataEmployee.map(
          (data) => data.sName + " " + data.sSurName
        );
      });

    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sComCode", this.nComcode + ""),
    };
    let _this = this;
    this.http
      .get<any>(this.System.SiteName + "api/_System/GetCustomer", httpOptions)
      .toPromise()
      .then((data) => {
        this.DataVendorAll = data;
        data.filter(function (item) {
          _this.DataVendor.push(item);
        });
        this.ArrVendor = this.DataVendor.map((re) => ({
          Customer: re.CUSTOMER_CODE + " - " + re.VENDORNAME,
          CUSTOMER_CODE: re.CUSTOMER_CODE,
          sAddress: re.ADDRESS,
          sVendorName: re.VENDORNAME,
          TAX_NUMBER1: re.TAX_ID,
          IsOnetimeVendor: re.IsOnetimeVendor,
        }));
      });

    this.ArrRequest = [];
    this.http
      .get(
        this.System.SiteName +
          "api/_Paytovendor/GetCopyB2P/" +
          this.nComcode +
          ""
      )
      .subscribe((data: Response) => {
        this.DataRequest = data;
        if (this.DataRequest != null) {
          this.ArrRequest = this.DataRequest.map((re) => re.sRequestCode);
        }
      });

    const httpOptions_GL = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    await this.http
      .get(this.System.SiteName + "api/_System/GetGL", httpOptions_GL)
      .toPromise()
      .then((data: Response) => {
        this.DataGL = data;
        this.sArrGL = this.DataGL;
      });

    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    this.http
      .get(
        this.System.SiteName + "api/_System/GetCostCenter",
        httpOptions_CostCenter
      )
      .subscribe((data: Response) => {
        this.DataCostCenter = data;
        this.ArrCostCenter = this.DataCostCenter;
      });

    const httpOptions_IO = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    await this.http
      .get(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO)
      .toPromise()
      .then((data: Response) => {
        this.DataIO = data;
        if (this.DataIO != null) {
          this.ArrIO = this.DataIO;
          this.ArrMaster[0] = this.ArrIO;
        }
      });

    const httpOptions_ProfitCenter = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      params: new HttpParams().set("sCompCode", this.nComcode),
    };
    await this.http
      .get(
        this.System.SiteName + "api/_System/GetProfitCenter",
        httpOptions_ProfitCenter
      )
      .toPromise()
      .then((data: Response) => {
        if (data != null) {
          this.DataProfitCenter = data;
          this.ArrProfitCenter = this.DataProfitCenter;
        }
      });

    await this.http
      .get(
        this.System.SiteName +
          "api/_Paytovendor/GetApproverAll/" +
          this.nComcode +
          ""
      )
      .toPromise()
      .then((data: Response) => {
        if (data) {
          this.DataApprover = data;
        } else {
          this.DataApprover = [];
        }

        this.ArrApprover[0] = [];
        this.ArrApprover[1] = [];

        this.http
          .get(
            this.System.SiteName +
              "api/_Paytovendor/GetApprover/" +
              this.nComcode +
              "/90"
          )
          .toPromise()
          .then((data: Response) => {
            if (data) {
              this.GetApprover = data[0];
            } else {
              this.GetApprover = null;
            }
            if (this.GetApprover != null) {
              if (this.GetApprover.cActive == "Y") {
                this.ArrApprover[0] = this.DataApprover.filter(
                  (f) => f.nRole == 3
                );
                this.ArrApprover[1] = this.DataApprover.filter(
                  (f) => f.nRole == 4
                );
                if (this.GetApprover.IsApprover_1 == false) {
                  this.paytovendorForm.controls["ddApprover1"].disable();
                  this.paytovendorForm.controls["cSkipApprove1"].setValue(true);
                } else {
                  this.paytovendorForm.controls["ddApprover1"].enable();
                  let name1 = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name1ID
                  )[0];
                  let nUserId = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name1ID
                  )[0];
                  this.paytovendorForm.patchValue({
                    ddApprover1:
                      isNullOrUndefined(name1) == true ? "" : name1.name1,
                    sApprove1:
                      isNullOrUndefined(nUserId) == true
                        ? null
                        : nUserId.nUserID,
                  });
                }
                if (this.GetApprover.IsApprover_2 == false) {
                  this.paytovendorForm.controls["ddApprover2"].enable();
                } else {
                  this.paytovendorForm.controls["ddApprover2"].enable();

                  let name1 = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name2ID
                  )[0];
                  let nUserId = this.DataApprover.filter(
                    (f) => f.nUserID == this.GetApprover.name2ID
                  )[0];
                  this.paytovendorForm.patchValue({
                    ddApprover2:
                      isNullOrUndefined(name1) == true ? "" : name1.name1,
                    sApprove2:
                      isNullOrUndefined(nUserId) == true
                        ? null
                        : nUserId.nUserID,
                  });
                }
              } else if (this.GetApprover.cActive == "N") {
                this.ArrApprover[0] = this.DataApprover.filter(
                  (f) => f.nRole == 3
                );
                this.ArrApprover[1] = this.DataApprover.filter(
                  (f) => f.nRole == 4
                );
              }
            }
          });
      });

    this.http
      .get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*")
      .subscribe((data: Response) => {
        this.Currency = data;
      });

    await this.http
      .get(
        this.System.SiteName +
          "api/Autocomplete/MT_BANK/*/Company/" +
          this.nComcode +
          "/Transfer/Y"
      )
      .subscribe((data: Response) => {
        this.Bank = data;
        if (this.Bank.length == 1) {
          this.paytovendorForm.patchValue({
            ddBank: this.Bank[0].BankName,
          });
        }
      });

    this.http
      .get(
        this.System.SiteName + "api/Autocomplete/Like/MT_VATTYPE/*/sReqType/90"
      )
      .subscribe((data: Response) => {
        let tempData: any;
        tempData = data;
        this.VatType = tempData;
      });

    this.http
      .get<any>(this.System.SiteName + "api/Autocomplete/MT_BUSINESS_AREA/*")
      .subscribe((data) => {
        if (data != null) {
          this.DataBusinessArea = data;
          this.paytovendorForm.patchValue({
            sBusinessArea: this.DataBusinessArea.filter(
              (f) => f.CompCode == this.nComcode
            )[0].BUSINESS_AREA,
          });
        }
      });
  }
  onUserSelect(sName) {
    let lstData = this.DataEmployee.filter(
      (user) => user.sName + " " + user.sSurName == sName
    )[0];
    if (lstData != undefined) {
      this.nComcode = lstData.sCompCode;
      this.paytovendorForm.patchValue({
        nContactID: lstData.sEmpCode,
        sName: lstData.sName + " " + lstData.sSurName,
        sEmail: lstData.sEmail,
        sUnit: lstData.sUnit,
        sTel: lstData.sTel,
      });
    } else {
    }
  }

  async onCopyRequestCodeSelect(RequestCode) {
    if (RequestCode != "") {
      let Data: any;
      let lstData = this.DataRequest.filter(
        (user) => user.sRequestCode == RequestCode
      )[0];
      await this.http
        .get(
          this.System.SiteName +
            "api/_paytovendor/GetRequest/" +
            lstData.sRequestID +
            ""
        )
        .toPromise()
        .then((data: any) => {
          this.ClearInvoice();
          Data = data.filter((f) => f.cActive != "N");
        });

      if (Data == null || Data.length === 0) return;
      this.ArrInvoice = Data;

      this.paytovendorForm.patchValue({
        nCopyRequest: Data[0].sRequestID,
        nVendorCode: Data[0].sVendorCode,
        sOtherRefNoFIDocNo: Data[0].sOtherRefNoFIDocNo,
        sDescription: Data[0].sDescription,
        sTAXID: Data[0].sTAXID,
        sVendorName: Data[0].sVendorName,
        cbOffice: Data[0].nOfficeType,
        cbReceiveTypeB2C: Data[0].nReceiveTypeB2C,
        sBranch: Data[0].sVendorBranch,
        sAddress: Data[0].sVendorAddress,
        sCountryID: Data[0].sCountryID,
        sProvCode: Data[0].sProvCode,
        sProvName: Data[0].sProvName,
        sAmpCode: Data[0].sAmpCode,
        sAmpName: Data[0].sAmpName,
        sTumbonCode: Data[0].sTumbonCode,
        sTumbonName: Data[0].sTumbonName,
        sPostCode: Data[0].sPostCode,
        sPhoneNumber: Data[0].sPhoneNumber,
        sFaxNumber: Data[0].sFaxNumber,
        sVendorEmail: Data[0].sVendorEmail,
        sAddressOneTime: Data[0].sAddressOneTime,
        ddApprover1: Data[0].sUserApprove1,
        ddApprover2: Data[0].sUserApprove2,
        sApprove1: Data[0].nApprove1 == null ? null : Data[0].nApprove1,
        sApprove2: Data[0].nApprove2 == null ? null : Data[0].nApprove2,
        cSkipApprove1: Data[0].cSkipApprove1 == "Y" ? true : false,
        nAmount: Data[0].nIncludeVAT ? this._ConvertToDecimal(Data[0].nIncludeVAT) : '0.00',
        nWHTAmount: Data[0].nWHTVal ? this._ConvertToDecimal(Data[0].nWHTVal) : '0.00',
      });
      if (Data[0].cSkipApprove1 == "Y") {
        this.paytovendorForm.get("ddApprover1").disable();
      } else {
        this.paytovendorForm.get("ddApprover1").enable();
      }
      this.hBranch = Data[0].nOfficeType == 2 ? false : true;
      if (this.hBranch == false) {
        this.paytovendorForm.controls["sBranch"].enable();
        this.paytovendorForm.patchValue({
          sBranch: Data[0].sVendorBranch,
          cbOffice: Data[0].nOfficeType,
        });
      }
      this.CheckInvoice();
    }
  }
  unique = (value, index, self) => {
    return self.indexOf(value) === index;
  };
  forPX = () => {
    var vendor = this.paytovendorForm.value.nVendorCode + "XX";
    vendor = vendor.substring(0, 2);
    var isNotPX = vendor === "PX";
    return isNotPX;
  };
  async onVendorSelect(event) {
    let _this = this;

    if (
      event.item.CUSTOMER_CODE != undefined &&
      event.item.CUSTOMER_CODE != ""
    ) {
      let lstData = this.DataVendor.filter(
        (s) => s.CUSTOMER_CODE == event.item.CUSTOMER_CODE
      )[0];
      if (lstData != "") {
        let value = {
          sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID,
        };

        let tax = lstData.TAX_ID == null ? "-" : lstData.TAX_ID;

        this.paytovendorForm.patchValue({
          nVendorCode: lstData.CUSTOMER_CODE,
          sTAXID: tax,
          sVendorName: lstData.VENDORNAME,
          sAddress: lstData.ADDRESS,
          sPhoneNumber: lstData.TEL,
          cbOffice:
            isNullOrUndefined(lstData.nOfficeType) == true
              ? 1
              : lstData.nOfficeType,
          sAmpCode: lstData.sAmpCode,
          sAmpName: "",
          sBranch: lstData.sBranch,
          sComcode: lstData.sComcode,
          sCountryID: "213",
          txtCountryID: "ประเทศไทย (Thailand)",
          sVendorEmail: lstData.sEMAIL,
          sFaxNumber: lstData.sFaxNumber,
          sPostCode: lstData.sPostCode,
          sProvCode: lstData.sProvCode,
          sProvName: "",
          sTumbonCode: lstData.sTumbonCode,
          sTumbonName: "",
        });

        if (
          lstData.nOfficeType == 1 ||
          isNullOrUndefined(lstData.nOfficeType) == true
        ) {
          this.paytovendorForm.controls["sBranch"].disable();
        }

        if (isNullOrUndefined(lstData.sCountryID) == true) {
          this.isThai = true;
          this.paytovendorForm.patchValue({
            txtCountryID: "ประเทศไทย (Thailand)",
            sCountryID: "213",
            sProvCode: "",
            sAmpCode: "",
            sTumbonCode: "",
            sPostCode: "",
            sPhoneNumber: "",
            sFaxNumber: "",
            sVendorEmail: "",
            sAddressOneTime: "",
          });
        }
      } else {
        this.paytovendorForm.patchValue({
          nVendorCode: null,
          sTAXID: null,
          sVendorName: null,
          cbOffice: 1,
          sBranch: null,
          sAddress: null,
        });
      }
    }
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      let lstData = _this.DataVendor.filter(
        (s) => s.CUSTOMER_CODE == event.item.CUSTOMER_CODE
      )[0];

      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(async function (
        invoice
      ) {
        let taxID = "";
        if (lstData != "") {
          if (lstData.TAX_NUMBER3 != null) {
            taxID = lstData.TAX_NUMBER3;
          } else if (
            lstData.TAX_NUMBER3 == null &&
            lstData.TAX_NUMBER2 != null
          ) {
            taxID = lstData.TAX_NUMBER2;
          } else {
            taxID = lstData.TAX_NUMBER1;
          }
        }

        if (
          _IsNullOrEmpty(lstData.VENDORNAME) ||
          _IsNullOrEmpty(lstData.ADDRESS)
        ) {
          _this.SW.SwAlert.Error(
            _this.SW.BoxMsg.Title_Error,
            _this.SW.BoxMsg.Desc_Specify_AddInvoice,
            undefined
          );
          return false;
        }

        let tax = lstData.TAX_ID == null ? "-" : lstData.TAX_ID;
        let address = lstData.ADDRESS == null ? "-" : lstData.ADDRESS;

        invoice.IsVendorOneTime = lstData.IsOnetimeVendor;
        invoice.sVendorCode = lstData.CUSTOMER_CODE;
        invoice.sTAXID = tax;
        invoice.sVendorName = lstData.VENDORNAME;
        invoice.cbOffice =
          isNullOrUndefined(lstData.nOfficeType) == true
            ? 1
            : lstData.nOfficeType;
        invoice.sVendorBranch = lstData.sBranch;
        invoice.sVendorAddress = address;
        invoice.sCountryID = "213";
        invoice.sProvCode = "";
        invoice.sProvName = lstData.sProvName;
        invoice.sAmpCode = "";
        invoice.sAmpName = lstData.sAmpName;
        invoice.sTumbonCode = "";
        invoice.sTumbonName = lstData.sTumbonName;
        invoice.sPostCode = lstData.sPostCode;
        invoice.sPhoneNumber = lstData.TEL;
        invoice.sFaxNumber = lstData.sFaxNumber;
        invoice.sVendorEmail = lstData.sEMAIL;

        if (lstData.IsOnetimeVendor == true) {
          const httpOptions_VendorOT = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            }),
            params: new HttpParams()
              .set("sComCode", _this.nComcode)
          };
          let VendorOT = await _this.http.get<any>(_this.System.SiteName + "api/_System/GetCustomerOneTime", httpOptions_VendorOT).toPromise();
          if (VendorOT) {
            _this.ArrVendorName = VendorOT;
          }
        }
        else {
          _this.ArrVendorName = [];
        }

      });
    }
  }
  checkrange() {
    let _this = this;
    var st = this.paytovendorForm.get("nVendorCode").value.length;
    if (st > 10) {
      let clear = function () {
        _this.paytovendorForm.get("nVendorCode").setValue("");
      };
      this.SW.SwAlert.Error(
        _this.SW.BoxMsg.Title_Error,
        _this.SW.BoxMsg.DescOneVendorLength,
        clear
      );
    }
  }

  async VendorNameChange(event) {
    let _this = this;
    let lstData = event.item;
    let check = this.ArrVendorName.filter(
      (f) => f.sVendorName == lstData.sVendorName
    )[0];
    let sVendorName = this.paytovendorForm.get("sVendorName").value;
    lstData = check;
    if (check != null && !_IsNullOrEmpty(sVendorName)) {
      let value = {
        sCountryID: lstData.sCountryID == null ? "" : lstData.sCountryID,
      };
      this.paytovendorForm.patchValue({
        sTAXID: _IsNullOrEmpty(lstData.sTAXID) ? "" : lstData.sTAXID,
        sAddress: lstData.sAddress == null ? "" : lstData.sAddress,
        sPhoneNumber: lstData.TEL,
        cbOffice:
          isNullOrUndefined(lstData.nOfficeType) == true
            ? 1
            : lstData.nOfficeType,
        sAmpCode: lstData.sAmpCode == null ? "" : lstData.sAmpCode,
        sAmpName: lstData.sAmpName,
        sBranch: lstData.sBranch,
        sComcode: lstData.sComcode,
        sCountryID:
          isNullOrUndefined(lstData.sCountryID) == true
            ? "213"
            : lstData.sCountryID,
        txtCountryID: "ประเทศไทย (Thailand)",
        sVendorEmail: lstData.sEMAIL,
        sFaxNumber: lstData.sFaxNumber,
        sPostCode: lstData.sPostCode,
        sProvCode: lstData.sProvCode == null ? "" : lstData.sProvCode,
        sProvName: lstData.sProvName,
        sTumbonCode: lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
        sTumbonName: lstData.sTumbonName,
      });
      if (
        lstData.nOfficeType == 1 ||
        isNullOrUndefined(lstData.nOfficeType) == true
      ) {
        this.paytovendorForm.controls["sBranch"].disable();
      }
      if (lstData.sCountryID != "213") {
      } else {
        this.isThai = true;
        let sfield = [
          "txtCountryID",
          "sProvCode",
          "sAmpCode",
          "sTumbonCode",
          "sProvName",
          "sAmpName",
          "sTumbonName",
        ];
        sfield.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].setValidators([
            Validators.required,
          ]);
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        });
        let sfieldS = ["sPostCode", "sPhoneNumber", "sFaxNumber"];
        sfieldS.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        });
        _this.paytovendorForm.controls["sVendorEmail"].enable();
        _this.paytovendorForm.controls["sVendorEmail"].setValidators(
          Validators.email
        );
        _this.paytovendorForm.controls["sVendorEmail"].updateValueAndValidity();
      }
      if (lstData.sCountryID == null) {
        let sfield = [
          "txtCountryID",
          "sProvCode",
          "sAmpCode",
          "sTumbonCode",
          "sProvName",
          "sAmpName",
          "sTumbonName",
        ];
        sfield.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].setValidators([
            Validators.required,
          ]);
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        });
        let sfieldS = ["sPostCode", "sPhoneNumber", "sFaxNumber"];
        sfieldS.forEach(function (value) {
          _this.paytovendorForm.controls[value].enable();
          _this.paytovendorForm.controls[value].updateValueAndValidity();
        });
        _this.paytovendorForm.controls["sVendorEmail"].enable();
        _this.paytovendorForm.controls["sVendorEmail"].setValidators(
          Validators.email
        );
        _this.paytovendorForm.controls["sVendorEmail"].updateValueAndValidity();
        this.isThai = true;
        this.paytovendorForm.patchValue({
          txtCountryID: "ประเทศไทย (Thailand)",
          sCountryID: "213",
          sProvCode: "",
          sAmpCode: "",
          sTumbonCode: "",
          sPostCode: "",
          sPhoneNumber: "",
          sFaxNumber: "",
          sVendorEmail: "",
          sAddressOneTime: "",
        });
      }
    } 
    else if (!this.paytovendorForm.get("sVendorName").value || (!this.paytovendorForm.get("sTAXID").value && !this.paytovendorForm.get("sAddress").value)) {
      lstData = {};
      this.paytovendorForm.patchValue({
        txtCountryID: "ประเทศไทย (Thailand)",
        sTAXID: null,
        cbOffice: 1,
        sBranch: null,
        sAddress: null,
        sCountryID: "213",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
        sAddressOneTime: "",
      });
    }
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sTAXID = _IsNullOrEmpty(lstData.TAX_ID) ? "" : lstData.TAX_ID;
        invoice.sVendorName = isNullOrUndefined(lstData.sVendorName)
          ? event.value
          : lstData.sVendorName;
        invoice.cbOffice =
          isNullOrUndefined(lstData.nOfficeType) == true
            ? 1
            : lstData.nOfficeType;
        invoice.sVendorBranch = isNullOrUndefined(lstData.sBranch)
          ? ""
          : lstData.sBranch;
        invoice.sVendorAddress = isNullOrUndefined(lstData.ADDRESS)
          ? ""
          : lstData.ADDRESS;
        invoice.sCountryID = isNullOrUndefined(lstData.sCountryID)
          ? "213"
          : lstData.sCountryID;
        invoice.sProvCode = "";

        invoice.sAmpName = null;
        invoice.sTumbonCode = "";
        invoice.sTumbonName = null;
        invoice.sPostCode = isNullOrUndefined(lstData.sPostCode)
          ? ""
          : lstData.sPostCode;
        invoice.sPhoneNumber = isNullOrUndefined(lstData.TEL)
          ? ""
          : lstData.TEL;
        invoice.sFaxNumber = isNullOrUndefined(lstData.sFaxNumber)
          ? ""
          : lstData.sFaxNumber;
        invoice.sVendorEmail = isNullOrUndefined(lstData.sEMAIL)
          ? ""
          : lstData.sEmail;
      });
    }

    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        if (event.target.value != null && !_IsNullOrEmpty(sVendorName)) {
          invoice.sVendorName =
            event.target.value == null ? "" : event.target.value;
        } else {
          invoice.sVendorName = "";
        }
      });
    }
  }
  CommentChange(event) {
    this.paytovendorForm.patchValue({
      sComment: event.target.value,
    });
    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.paytovendorForm.patchValue({
      sCommentSSC: event.target.value,
    });
    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }
  TAXIDChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sTAXID = event.target.value == null ? "" : event.target.value;
      });
    }
  }
  AddressChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sVendorAddress =
          event.target.value == null ? "" : event.target.value;
      });
    }
  }

  BranchChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sVendorBranch =
          event.target.value == null ? "" : event.target.value;
      });
    }
  }
  PostCodeChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sPostCode =
          event.target.value == null ? "" : event.target.value;
      });
    }
  }
  PhoneNumberChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sPhoneNumber =
          event.target.value == null ? "" : event.target.value;
      });
    }
  }
  FaxNumberChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sFaxNumber =
          event.target.value == null ? "" : event.target.value;
      });
    }
  }
  EmailChange(event) {
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
      this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
        invoice
      ) {
        invoice.sVendorEmail =
          event.target.value == null ? "" : event.target.value;
      });
    }
  }

  async onCostCenterSelect(sCost, row) {
    let _this = this;
    if (sCost != undefined && sCost != "") {
      let lstData = this.DataCostCenter.filter(
        (s) => s.COST_CENTER == sCost
      )[0];
      const httpOptions_IO = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
        }),
        params: new HttpParams().set("sCompCode", this.nComcode),
      };

      await this.http
        .get(_this.System.SiteName + "api/_System/GetIO2", httpOptions_IO)
        .toPromise()
        .then((data: Response) => {
          this.DataIO = data;
          if (this.DataIO != null) {
            this.ArrMaster[row] = this.DataIO;
          } else {
            this.ArrMaster[row] = ["", ""];
          }
        });
    }
  }
  async AddInvoice(mode: number) {
    if (this.isEdit1 || this.isEdit2) {
      this.EditInvoice(mode, this.nEditIndex, true);
    } else {
      let _this = this;
      let _FormGroup = this.paytovendorForm;
      let FieldValid: string[];
      FieldValid = [
        "sInvoiceNo2",
        "nAmount2",
        "sGL",
        "sProfitCenter",
      ];
      let InvoiceNo = this.paytovendorForm.get("sInvoiceNo").value;

      if (mode === 2) {
        FieldValid.forEach(function (Field) {
          const control = _FormGroup.get(Field);
          if (control instanceof FormControl && control.status != "DISABLED") {
            control.markAsTouched({ onlySelf: true });
          }
        });
        InvoiceNo = this.paytovendorForm.get("sInvoiceNo2").value;
      }

      if (!InvoiceNo) return false;

        let arrGL = this.paytovendorForm.value.ArrGL;
        let sCurrency = this.paytovendorForm.get("ddCurrency").value;
        _this.Currencys = sCurrency;
        let CheckDupInvoice = this.ArrInvoice.filter(
          (m) =>
            m.sInvoiceNo === mode.toString() &&
            m.sText === InvoiceNo &&
            m.IsDelete === false
        );

        if (CheckDupInvoice.length == 0) {
          arrGL
            .filter((f) => f.IsDelete != true)
            .forEach(function () {
              let nLine =
                _this.ArrInvoice.length >= 1
                  ? _this.ArrInvoice.filter(
                      (f) => f.sInvoiceNo == mode && f.IsDelete == false
                    ).length
                  : 0;
              let arr = {
                sInvoiceNo: mode.toString(),
                nLine: nLine + 1,
                sText: InvoiceNo,
                sCurrency: sCurrency,
                IsDelete: false,
                nItemNo: mode,
              };

              if (mode === 2) {
                let nAmount2 = _this.paytovendorForm.get("nAmount2").value;
                let sGL = _this.paytovendorForm.get("sGL").value;
                let sCostCenter =
                  _this.paytovendorForm.get("sCostCenter").value;
                let sIO = _this.paytovendorForm.get("sIO").value;
                let sProfitCenter =
                  _this.paytovendorForm.get("sProfitCenter").value;

                arr["sGL"] = sGL;
                arr["sCostCenter"] = sCostCenter;
                arr["sIO"] = sIO;
                arr["sProfitCenter"] = sProfitCenter;
                arr["sAmount"] = _ParseFloatToZero(nAmount2);
              }

              _this.ArrInvoice.push(arr);

              _this.calGrand();
            });
          this.ClearSubInvoice(mode);

          const options = { headers: { "Content-Type": "application/json" } };
          _this.http
            .post<any>(
              _this.System.SiteName + "api/_Paytovendor/LogInvoice",
              JSON.stringify(_this.ArrInvoice),
              options
            )
            .subscribe(() => {});
        } else {
          this.SW.SwAlert.Error(
            this.SW.BoxMsg.Title_Error,
            this.SW.BoxMsg.Desc_Receipt_Duplicate,
            undefined
          );
        }
    }
    this.calGrand();
  }
  ClearInvoice() {
    let _this = this;
    this.isEdit1 = false;
    this.isEdit2 = false;
    let FieldValid: string[] = [
      "sTAXID",
      "sVendorName",
      "nVendorCode",
      "dInvoiceDate",
      "ddVatType",
      "nTotalAmountVat",
      "txtCountryID",
      "sPostCode",
      "sPhoneNumber",
      "sFaxNumber",
      "sVendorEmail",
    ];
    for (let i = 0; i < FieldValid.length; i++) {
      _this.paytovendorForm.get(FieldValid[i]).markAsUntouched();
    }
    let sCurrency =
      _this.ArrInvoice.filter((f) => f.IsDelete != true).length > 0
        ? _this.paytovendorForm.get("ddCurrency").value
        : "THB";
    if (_this.ArrInvoice.filter((f) => f.IsDelete != true).length == 0) {
      this.paytovendorForm.patchValue({
        nVendorCode: "",
        sTAXID: "",
        sVendorName: "",
        cbOffice: 1,
        sBranch: "",
        sAddress: "",
        sCountryID: "",
        sProvCode: "",
        sProvName: "",
        sAmpCode: "",
        sAmpName: "",
        sTumbonCode: "",
        sTumbonName: "",
        sPostCode: "",
        sPhoneNumber: "",
        sFaxNumber: "",
        sVendorEmail: "",
      });
    } else {
      this.paytovendorForm.patchValue({
        sInvoiceNo: null,
        dInvoiceDate: new Date(),
        nTotalAmount: null,
        ddCurrency: sCurrency,
        nVat: null,
        ddVatType: "-1",
        nTotalAmountInvoice: null,
        nTotalAmountVat: null,
        nWHTVal: null,
      });
    }
    if (this.paytovendorForm.get("cbOffice").value == 1) {
      this.paytovendorForm.controls["sBranch"].disable();
    }
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear();
    this._paytovendorForm.ArrGL.reset();
    this.ArrGL.push(
      new FormGroup({
        sGL: new FormControl("", Validators.required),
        sCostCenter: new FormControl(""),
        sIO: new FormControl(""),
        sProfitCenter: new FormControl("", Validators.required),
        sAmountExcludedVAT: new FormControl("", Validators.required),
        sText: new FormControl("", Validators.required),
        IsDelete: new FormControl(false),
        sInvoiceNo: new FormControl(null),
        nline: new FormControl(""),
      })
    );
  }
  KeyWithholding(event: any) {
    if (event.target.value === '') {
        this.paytovendorForm.patchValue({
          nWHTAmount: '0.00',
        })
    }
  }
  calGrand(){
    let grandTotal = 0;
    grandTotal += _ParseFloatToZero(
      this.paytovendorForm.get("nAmount").value
    );
    grandTotal -= _ParseFloatToZero(
      this.paytovendorForm.get("nWHTAmount").value
    );
    this.ArrInvoice.forEach((item) => {
      if (item.nItemNo === 2 && item.IsDelete === false) grandTotal += item.sAmount;
    });
    this.paytovendorForm.patchValue({
      GtotalAmountExcluded: grandTotal,
    });
  }
  DeleteInvoice(index) {
    let _this = this;
    let del = function () {
      let invoice = _this.ArrInvoice[index];
      invoice.cActive = "N";
      invoice.IsDelete = true;
      invoice.nLine = invoice.nLine == null ? 1 : invoice.nLine;

      _this.CheckInvoice();
    };
    this.SW.SwAlert.Confirm(
      this.SW.BoxMsg.Title_Confirm,
      this.SW.BoxMsg.Desc_Confirm_Delete,
      del,
      function () {}
    );
  }
  async EditInvoice(mode: number, index: number, save: boolean) {
    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    let _this = this;
    let data = this.ArrInvoice[index];
    if (!save) {
     
      this.ArrGL.clear();
      this._paytovendorForm.ArrGL.reset();
      this.nEditIndex = index;

      if (mode === 1) {
        this.isEdit1 = true;
        this.paytovendorForm.patchValue({
          sInvoiceNo: data.sText,
        });
      } else {
        this.isEdit2 = true;
        this.paytovendorForm.patchValue({
          sInvoiceNo2: data.sText,
          nAmount2: !isNullOrUndefined(data.sAmount)
            ? _this._ConvertToDecimal(data.sAmount)
            : 0,
          sGL: data.sGL,
          sCostCenter: data.sCostCenter,
          sIO: data.sIO,
          sProfitCenter: data.sProfitCenter,
        });
      }
    }
    if (save) {
      let pass = true;
      let _FormGroup = this.paytovendorForm;
      let FieldValid: string[];

      FieldValid = [
        "sInvoiceNo2",
        "nAmount2",
        "sGL",
        "sCostCenter",
        "sIO",
        "sProfitCenter",
      ];
      let InvoiceNo = this.paytovendorForm.get("sInvoiceNo").value;

      if (mode === 2) {
        FieldValid.forEach(function (Field) {
          const control = _FormGroup.get(Field);
          if (control instanceof FormControl && control.status === "INVALID") {
            control.markAsTouched({ onlySelf: true });
            pass = false;
            return pass;
          }
        });
        InvoiceNo = this.paytovendorForm.get("sInvoiceNo2").value;
      }

      if (pass) {
        let CheckDupInvoice = this.ArrInvoice.filter(
          (m) =>
            m.sInvoiceNo === mode.toString() &&
            m.sText === InvoiceNo &&
            m.IsDelete === false
        );

        if (CheckDupInvoice.length === 0 || data.sText === InvoiceNo) {
          let _this = this;

          let data = this.ArrInvoice[index];
          let nLine = data.nLine;
          let arrData = _this.ArrInvoice.filter(
            (f) => f.sInvoiceNo == mode && f.nLine == nLine
          );
          if (arrData.length > 0) {
            let nAmount2 = null;
            let sGL = null;
            let sCostCenter = null;
            let sIO = null;
            let sProfitCenter = null;

            if (mode === 2) {
              nAmount2 = _this.paytovendorForm.get("nAmount2").value;
              sGL = _this.paytovendorForm.get("sGL").value;
              sCostCenter = _this.paytovendorForm.get("sCostCenter").value;
              sIO = _this.paytovendorForm.get("sIO").value;
              sProfitCenter = _this.paytovendorForm.get("sProfitCenter").value;
              nAmount2 = _ParseFloatToZero(nAmount2);
            }

            arrData.forEach(function (value) {
              (value.sText = InvoiceNo),
                (value.sAmount = nAmount2),
                (value.sGL = sGL),
                (value.sCostCenter = sCostCenter),
                (value.sIO = sIO),
                (value.sProfitCenter = sProfitCenter);
            });
          }

          this.ClearSubInvoice(1);
          this.ClearSubInvoice(2);
          this.CheckInvoice();
          const options = { headers: { "Content-Type": "application/json" } };
          _this.http
            .post<any>(
              _this.System.SiteName + "api/_Paytovendor/LogInvoice",
              JSON.stringify(_this.ArrInvoice),
              options
            )
            .subscribe(() => {});
        } else {
          this.SW.SwAlert.Error(
            this.SW.BoxMsg.Title_Error,
            this.SW.BoxMsg.Desc_Receipt_Duplicate,
            undefined
          );
          return false;
        }
      }
    }
  }
  onApprover1(value) {
    let ckNull = this.paytovendorForm.get("ddApprover1").value;
    let ischeck = this.ArrApprover[0].filter((f) => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytovendorForm.patchValue({
        sApprove1: null,
      });
    } else if (this.Approve1NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        sApprove1: value.item.nUserID,
      });
    } else if (this.Approve1NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      });
    }
    if (this.Approve1NoResult == true) {
      this.paytovendorForm.patchValue({
        ddApprover1: null,
        sApprove1: null,
      });
    }
  }
  onApprover2(value) {
    let ckNull = this.paytovendorForm.get("ddApprover2").value;
    let ischeck = this.ArrApprover[1].filter((f) => f.name1 == ckNull)[0];
    if (ckNull == "") {
      this.paytovendorForm.patchValue({
        sApprove2: null,
      });
    } else if (this.Approve2NoResult == false && !isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        sApprove2: value.item.nUserID,
      });
    } else if (this.Approve2NoResult == false && isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      });
    }
    if (this.Approve2NoResult == true) {
      this.paytovendorForm.patchValue({
        ddApprover2: null,
        sApprove2: null,
      });
    }
  }

  onSubmit() {}

  async Save(mode) {
    let _this = this;
    let _FormGroup = this.paytovendorForm;
    let IsValid: boolean = true;
    if (ArrFile.filter((f) => f.IsDelete === false).length <= 0 && mode !== 1) {
      IsValid = false;
      const chkFile = document.getElementById("dv_dvFile");
      chkFile.style.border = "1px solid red";
    }
   
    let FieldValid: string[] = [];
    if (mode != 3) {
      if (mode == 1) {
        FieldValid = ["sName", "nVendorCode"];
      }
      if (
        mode == 2 &&
        this.ArrInvoice.filter((f) => f.cActive != "N").length == 0
      ) {
        FieldValid = [
          "sName",
          "dDueDate",
          "sInvoiceNo",
          "sVendorName",
          "sTAXID",
          "sAddress",
          "sDescription",
          "ddApprover2",
          "ddApprover1",
          "ddBank",
        ];
      }
      if (
        mode == 2 &&
        this.ArrInvoice.filter((f) => f.cActive != "N").length > 0
      ) {
        if (
          _IsNullOrEmpty(_this.paytovendorForm.get("sVendorName").value) ||
          _IsNullOrEmpty(_this.paytovendorForm.get("sAddress").value) ||
          _IsNullOrEmpty(_this.paytovendorForm.get("sTAXID").value)
        ) {
          _this.SW.SwAlert.Error(
            _this.SW.BoxMsg.Title_Error,
            _this.SW.BoxMsg.Desc_Specify_AddInvoice,
            undefined
          );
          _this.clicked = false;
          return false;
        }
        FieldValid = ["sDescription", "ddApprover2", "ddApprover1"];
        FieldValid.forEach(function (Field) {
          if (
            !_FormGroup.get(Field).valid &&
            _FormGroup.get(Field).disabled == false
          ) {
            IsValid = false;
          }
        });
      }
      if (this.ArrInvoice.filter((f) => f.cActive != "N").length == 0) {
        FieldValid.forEach(function (Field) {
          if (
            !_FormGroup.get(Field).valid &&
            _FormGroup.get(Field).disabled == false
          ) {
            IsValid = false;
          }
        });
        if (IsValid) {
          if (
            mode == 2 &&
            this.ArrInvoice.filter((f) => f.cActive != "N").length == 0
          ) {
            IsValid = false;
          }
          let FieldGLValid: string[] = [
            "sGL",
            "sProfitCenter",
            "sAmountExcludedVAT",
            "sText",
          ];
          for (let i = 0; i < this.ArrGL.length; i++) {
            FieldGLValid.forEach(function (Field) {
              let FromArray = _FormGroup.get("ArrGL") as FormArray;
              if (!FromArray.at(i).get(Field).valid && mode != 1) {
                IsValid = false;
                _this.clicked = false;
                return false;
              }
            });
          }
        }
      }

      if (IsValid) {
        let arr = [];
        let _ArrInvoice = _this.ArrInvoice;
        _ArrInvoice.sort((a, b) => a.nItemNo - b.nItemNo)
        let grandTotal = 0;
        let grandWHTTotal = 0;
        grandTotal += _ParseFloatToZero(
          _this.paytovendorForm.get("nAmount").value
        );
        grandWHTTotal = _ParseFloatToZero(
          _this.paytovendorForm.get("nWHTAmount").value
        );
        for (var i = 0; i < _ArrInvoice.length; i++) {
          let sGL = null;
          let sCostCenter = null;
          let sIO = null;
          let sProfitCenter = null;
          let sAmount = null;
          let nExcludeVAT = null;
          let nWHTVal = null;
          if (_ArrInvoice[i].nItemNo === 1) {
            nExcludeVAT = _ParseFloatToZero(
              _this.paytovendorForm.get("nAmount").value
            );
            nWHTVal = _ParseFloatToZero(
              _this.paytovendorForm.get("nWHTAmount").value
            );
          } else {
            sGL = _ArrInvoice[i].sGL;
            sCostCenter = _ArrInvoice[i].sCostCenter;
            sIO = _ArrInvoice[i].sIO;
            sProfitCenter = _ArrInvoice[i].sProfitCenter;
            sAmount = _ParseFloatToZero(_ArrInvoice[i].sAmount),
            grandTotal += _ArrInvoice[i].IsDelete ? 0 : sAmount
          }
          arr.push({
            sInvoiceNo: _ArrInvoice[i].sInvoiceNo,
            nLine: _ArrInvoice[i].nLine,
            sGL: sGL,
            sCostCenter: sCostCenter,
            sIO: sIO,
            sProfitCenter: sProfitCenter,
            sAmount: sAmount,
            sText: _ArrInvoice[i].sText,
            cVenderMaster: "M",
            sVendorCode: _this.paytovendorForm.get("nVendorCode").value,
            sVendorName: _this.paytovendorForm.get("sVendorName").value,
            sTAXID: _this.paytovendorForm.get("sTAXID").value,
            sVendorBranch: _this.paytovendorForm.get("sBranch").value,
            sVendorAddress: _this.paytovendorForm.get("sAddress").value,
            sCurrency: _this.paytovendorForm.get("ddCurrency").value,
            nExcludeVAT: nExcludeVAT,
            nIncludeVAT: nExcludeVAT,
            nWHTVal: nWHTVal,
            nOfficeType: _this.paytovendorForm.get("cbOffice").value,
            IsVendorOneTime: false,
            IsDelete: _ArrInvoice[i].IsDelete,
          });
        }
        let DataSave = {
          TRequest: {
            sRequestID: _this.paytovendorForm.get("sRequestID").value,
            sCompCode: _this.nComcode,
            nReqType: _this.paytovendorForm.get("ntype").value + "",
            nYear: _this.datepipe.transform(_this.today, "yyyy"),
            sRequestBy: _this.paytovendorForm.get("sRequestBy").value + "",
            dRequestDate: _this.dToday,
            nContactID: Number(_this.paytovendorForm.get("nContactID").value),
            sContactName: _this.paytovendorForm.get("sName").value,
            dDueDate: _this.datepipe.transform(
              _this.paytovendorForm.get("dDueDate").value,
              "dd/MM/yyyy"
            ),
            sDescription: _this.paytovendorForm.get("sDescription").value,
            sOtherRefNoFIDocNo:
              _this.paytovendorForm.get("sOtherRefNoFIDocNo").value,
            sUnitName: _this.paytovendorForm.get("sUnit").value,
            sEmail: _this.paytovendorForm.get("sEmail").value,
            sTel: _this.paytovendorForm.get("sTel").value,
            nInvoiceType: "",
            sRefAdvanceNo: "",
            IsReqUrgent: _this.IsReqUrgent,
            IsSSCUrgent: false,
            IsVendorGroup: false,
            sVendorCode: _this.paytovendorForm.get("nVendorCode").value,
            sCurrency: _this.paytovendorForm.get("ddCurrency").value,
            nStatusID: mode == 1 ? 1 : 2,
            sCopyReqID: _this.paytovendorForm.get("nCopyRequest").value,
            nStep: 1,
            nFlowNo: 1,
            sPaymentType: _this.paytovendorForm.get("cbChequeType").value,
            sBankName: _this.paytovendorForm.get("ddBank").value,
            sAccountName: _this.paytovendorForm.get("sBankAccountName").value,
            sAccountNo: _this.paytovendorForm.get("nBankAccountNo").value,
            sBankKey: _this.paytovendorForm.get("nBankKey").value,
            BankOther: _this.paytovendorForm.get("BankOther").value,
            nGrandTotalAmt: grandTotal,
            nGrandTotalAmtVat: 0,
            nGrandTotalWithholdingTax: grandWHTTotal,
            nGrandTotalAmtInvoice: grandTotal - grandWHTTotal,
            sCreateBy: _this.paytovendorForm.get("sRequestBy").value + "",
            sUpdateBy: _this.paytovendorForm.get("sRequestBy").value + "",
            sDeleteBy: "",
            cSkipApprove1:
              _this.paytovendorForm.get("cSkipApprove1").value == 1 ? "Y" : "N",
            nApprove1: _this.paytovendorForm.get("sApprove1").value,
            cApprove1: "W",
            nApprove2: _this.paytovendorForm.get("sApprove2").value,
            cApprove2: "W",
            cSkipApprove2: "N",
            sBusinessArea: _this.paytovendorForm.get("sBusinessArea").value,
            nReqUrgentDay: _this.nReqUrgentDay,
            dStartDate: _this.Settodate,
            nReceiveTypeB2C:
              _this.paytovendorForm.get("cbReceiveTypeB2C").value,
            sComment: _this.paytovendorForm.get("sComment").value,
            sCommentSSC: _this.paytovendorForm.get("sCommentSSC").value,
            sChequeNo: _this.paytovendorForm.get("sChequeNo").value,
            dChequeDate: _this.datepipe.transform(
              _this.paytovendorForm.get("dChequeDate").value,
              "dd/MM/yyyy"
            ),
            nChequeAmount: _ParseFloatToZero(
              _this.paytovendorForm.get("nChequeAmount").value
            ),
          },
          TRequestItems: arr,
          FileUp: ArrFile,
          CommentDelete: this.sComment,
        };

        let Data = JSON.stringify(DataSave);
        let saveDaft = function () {
          _this.System.BlockUI();
          _this.isEditFromhome = false;
          const headers = new HttpHeaders({
            "Content-Type": "application/json",
          });
          _this.http
            .post(_this.System.SiteName + "api/_Paytovendor/Save", Data, {
              headers,
              responseType: "text",
            })
            .subscribe((s) => {
              if (s == "Success") {
                ArrFile = [];
                _this.System.UnBlockUI();
                _this.SW.SwAlert.Success(
                  _this.SW.BoxMsg.Title_Success,
                  _this.SW.BoxMsg.Desc_SaveComplete,
                  function () {
                    _this.router.navigate(["home"]);
                  }
                );
              } else {
                _this.SW.SwAlert.Error(_this.SW.BoxMsg.Title_Error, s, undefined)
                _this.System.UnBlockUI();
              }
            });
        };
        let alertMessage = this.SW.BoxMsg.Desc_Confirm_Save ;

        if (_ParseFloatToZero(_this.paytovendorForm.value.GtotalAmountExcluded) !== _ParseFloatToZero(_this.paytovendorForm.value.nChequeAmount)){
          alertMessage = this.SW.BoxMsg.Desc_Cheque_TotalNoMatch;
        }
        
        this.SW.SwAlert.Confirm(
          this.SW.BoxMsg.Title_Confirm,
          alertMessage,
          saveDaft,
          function () {}
        );
      } else {
        FieldValid.forEach(function (Field) {
          const control = _FormGroup.get(Field);
          if (control instanceof FormControl && control.status != "DISABLED") {
            control.markAsTouched({ onlySelf: true });
          }
        });
      }
      if (this.ArrInvoice.filter((f) => f.cActive != "N").length == 0) {
        let FieldGLValid: string[] = [
          "sGL",
          "sProfitCenter",
          "sAmountExcludedVAT",
          "sText",
        ];
        for (let i = 0; i < this.ArrGL.length; i++) {
          FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get("ArrGL") as FormArray;
            const control = FromArray.at(i).get(Field);
            if (
              control instanceof FormControl &&
              mode != 1 &&
              control.status != "DISABLED"
            ) {
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      }
    }
    if (mode == 3) {
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytovendorForm.value.sRequestID,
          nStatusID: 3,
        },
      };
      let Data = JSON.stringify(DataSave);
      let SaveRecall = function () {
        _this.isEditFromhome = false;
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        _this.http
          .post(_this.System.SiteName + "api/_Paytovendor/Recall", Data, {
            headers,
            responseType: "text",
          })
          .subscribe((s) => {
            if (s == "Success") {
              _this.SW.SwAlert.Success(
                _this.SW.BoxMsg.Title_Success,
                _this.SW.BoxMsg.Desc_SaveComplete,
                function () {
                  _this.router.navigate(["home"]);
                }
              );
            }
          });
      };
      this.SW.SwAlert.Confirm(
        this.SW.BoxMsg.Title_Confirm,
        this.SW.BoxMsg.Desc_Confirm_Save,
        SaveRecall,
        function () {}
      );
    }
    _this.clicked = false;
  }
  cancel() {
    let _this = this;
    if (_this.sComment === null || _this.sComment === "") {
      this.SW.SwAlert.Error(
        this.SW.BoxMsg.Title_Error,
        this.SW.BoxMsg.Desc_Specify_Comment,
        undefined
      );
    } else {
      let DataSave = {
        TRequest: {
          sRequestID: _this.paytovendorForm.value.sRequestID,
          nStatusID: 0,
        },
        CommentDelete: this.sComment,
      };
      let Data = JSON.stringify(DataSave);
      let SaveRecall = function () {
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
        });
        _this.http
          .post(_this.System.SiteName + "api/_Paytovendor/cancel", Data, {
            headers,
            responseType: "text",
          })
          .subscribe((s) => {
            if (s == "Success") {
              _this.SW.SwAlert.Success(
                _this.SW.BoxMsg.Title_Success,
                _this.SW.BoxMsg.Desc_Success_Delete,
                function () {
                  _this.router.navigate(["home"]);
                }
              );
            }
          });
      };
      this.SW.SwAlert.Confirm(
        this.SW.BoxMsg.Title_Confirm,
        this.SW.BoxMsg.Desc_Confirm_Delete,
        SaveRecall,
        function () {}
      );
    }
  }

  async Edit(sReqID) {
    let _this = this;
    this.System.BlockUI();
    let Isnull = sReqID == "" ? true : false;
    const ua = this.System.GetUserStorage();
    if (this.isForROS) Isnull = true;
    if (ua.IsROService && Isnull) {
      this.isReject = true;
    }
    if (!Isnull) {
      _this.paytovendorForm.patchValue({ sRequestID: sReqID });
      _this.isDraft = true;
      _this.isPrint = true;
      _this.haveComments = true;
      await this.http
        .get(
          this.System.SiteName +
            "api/Autocomplete/TRequest/sRequestCode/sRequestID/" +
            sReqID +
            ""
        )
        .toPromise()
        .then((Data) => {
          if (Data) {
            if (
              !isNullOrUndefined(Data[0].sRequestCode) &&
              Data[0].sRequestCode != ""
            ) {
              _this.sReqCode = Data[0].sRequestCode;
              _this.haveRequestCode = true;
            }
          }
        });

      this.ArrMaster = [];
      this.ArrMaster.push(this.ArrIO);
      this.ArrGL.clear();
      this._paytovendorForm.ArrGL.reset();
      let data: any;
      let data2: any;
      await this.http
        .get(
          this.System.SiteName + "api/_Paytovendor/GetRequest/" + sReqID + ""
        )
        .toPromise()
        .then((Data) => (data = Data));
      _this.ArrInvoice = data;
      await this.http
        .get(
          this.System.SiteName +
            "api/_Paytovendor/GetTransactionHistory/" +
            sReqID +
            ""
        )
        .toPromise()
        .then((Data) => (data2 = Data));
      _this.ArrTransactionHistory = data2;
      if (_this.ArrInvoice != null) {
        _this.CheckInvoice();
        _this.ArrInvoice.forEach(function (value) {
          _this.paytovendorForm.patchValue({
            ntype: value.ntype,
            sComment: value.sComment,
            sCommentSSC: value.sCommentSSC,
          });
          _this.sComment = value.sComment;
          _this.sCommentSSC = value.sCommentSSC;
        });
      }
      let lstArrInvoice =
        _this.ArrInvoice != null
          ? _this.ArrInvoice.filter((f) => f.cActive != "N")
          : [];
      if (lstArrInvoice.length > 0) {
        if (
          lstArrInvoice[0].nStatusID == 1 ||
          lstArrInvoice[0].nStatusID == 3 ||
          lstArrInvoice[0].nStatusID == 5 ||
          lstArrInvoice[0].nStatusID == 7 ||
          lstArrInvoice[0].nStatusID == 10
        ) {
          let chunks = lstArrInvoice[0].dDueDate.split("/");
          this.toDay =
            lstArrInvoice[0].dRequestDate == null
              ? this.BusinessDay.SetToday(this.holidays)
              : new Date(lstArrInvoice[0].dRequestDate);
          let dDuedate = new Date(
            chunks[1] + "-" + chunks[0] + "-" + chunks[2]
          );

          if (
            (lstArrInvoice[0].nStatusID == 1 ||
              lstArrInvoice[0].nStatusID == 3 ||
              lstArrInvoice[0].nStatusID == 5 ||
              lstArrInvoice[0].nStatusID == 7 ||
              lstArrInvoice[0].nStatusID == 10) &&
            dDuedate < _this.Settodate
          ) {
            this.maxDate.setDate(this.maxDate.getDate() + 1);
            this.TODAY = this.BusinessDay.SetNextDate(
              this.maxDate,
              this.holidays
            );
          }
          await _this.http
            .get(
              _this.System.SiteName +
                "api/_paytovendor/GetRequest/" +
                lstArrInvoice[0].sCopyReqID +
                ""
            )
            .toPromise()
            .then((data: any) => {
              if (data != null) {
                let Data = data.filter((f) => f.cActive != "N");
                _this.paytovendorForm.patchValue({
                  sCopyRequest: Data[0].sRequestCode,
                });
              }
            });

          let isOntime: any;
          if (lstArrInvoice[0].sVendorCode != null) {
            if (lstArrInvoice[0].IsVendorOneTime) {
              isOntime = true;
            } else {
              isOntime = false;
            }
          }
          _this.isEditFromhome = true;

          this.hBranch = lstArrInvoice[0].nOfficeType == 2 ? false : true;

          if (this.hBranch == false) {
            this.paytovendorForm.controls["sBranch"].enable();
            this.paytovendorForm.patchValue({
              sBranch: lstArrInvoice[0].sVendorBranch,
              cbOffice: lstArrInvoice[0].nOfficeType,
            });
            if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
              this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
                invoice
              ) {
                invoice.cbOffice =
                  _this.paytovendorForm.value.cbOffice == 1
                    ? 1
                    : lstArrInvoice[0].cbOffice;
                invoice.nOfficeType =
                  _this.paytovendorForm.value.cbOffice == 1
                    ? 1
                    : _this.paytovendorForm.value.cbOffice;
                invoice.sVendorBranch = lstArrInvoice[0].sVendorBranch;
              });
            }
          } else {
            this.paytovendorForm.controls["sBranch"].disable();
            this.paytovendorForm.patchValue({
              sBranch: "",
              cbOffice: lstArrInvoice[0].nOfficeType,
            });
            if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
              this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
                invoice
              ) {
                invoice.cbOffice =
                  _this.paytovendorForm.value.cbOffice == 1
                    ? 1
                    : lstArrInvoice[0].cbOffice;
                invoice.nOfficeType =
                  _this.paytovendorForm.value.cbOffice == 1
                    ? 1
                    : _this.paytovendorForm.value.cbOffice;
                invoice.sVendorBranch = "";
              });
            }
          }
          let ddBankKey: any = [];
          if (!_IsNullOrEmpty(lstArrInvoice[0].sBankKey)) {
            let GetDT = await _this.http
              .get(
                _this.System.SiteName +
                  "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" +
                  lstArrInvoice[0].sBankKey +
                  ""
              )
              .toPromise();
            if (lstArrInvoice[0].sBankKey === "N/A") {
              GetDT = [{ NAME_OF_BANK: "N/A" }];
            }
            if (GetDT) {
              ddBankKey = GetDT;
            }
          } else {
            ddBankKey = [];
          }
          _this.ArrInvoice.forEach(function (value, i) {
            _this.Currencys = value.sCurrency;
            _this.isDraft =
              value.nStatusID == 1 ||
              value.nStatusID == 3 ||
              value.nStatusID == 5 ||
              value.nStatusID == 7 ||
              value.nStatusID == 10
                ? true
                : false;
            _this.isSubmit = value.nStatusID == 2 ? true : false;
            _this.isNew = true;
            _this.isPrint = true;
            _this.isThai = true;
            value.IsDelete = value.cActive == "N" ? true : false;
            if (value.cSkipApprove1 == "Y") {
              _this.paytovendorForm.get("ddApprover1").disable();
            } else {
              _this.paytovendorForm.get("ddApprover1").enable();
            }

            _this.paytovendorForm.patchValue({
              nContactID: value.nContactID + "",
              sName: value.sName,
              sEmail: value.sEmail,
              sUnit: value.sUnit,
              sTel: value.sTel,
              ntype: value.ntype,
              dDueDate: new Date(_this.convertTodate(value.dDueDate)),
              cbOffice:
                isNullOrUndefined(value.nOfficeType) == true
                  ? 1
                  : value.nOfficeType,
              cbReceiveTypeB2C: value.nReceiveTypeB2C,
              nCopyRequest: value.sCo3pyReqID,
              sDescription: value.sDescription,
              sOtherRefNoFIDocNo: value.sOtherRefNoFIDocNo,
              nVendorCode: value.sVendorCode,
              sVendorName: value.sVendorName,
              sTAXID: value.sTAXID,
              sBranch: value.sVendorBranch,
              sAddress: value.sVendorAddress,
              sCountryID: value.sCountryID,
              txtCountryID: "",
              sProvCode: value.sProvCode,
              sProvName: value.sProvName,
              sAmpCode: value.sAmpCode,
              sAmpName: value.sAmpName,
              sTumbonCode: value.sTumbonCode,
              sTumbonName: value.sTumbonName,
              sPostCode: value.sPostCode,
              sPhoneNumber: value.sPhoneNumber,
              sFaxNumber: value.sFaxNumber,
              sVendorEmail: value.sVendorEmail,
              sRequestID: value.sRequestID,
              sBankAccountName: value.sAccountName,
              cbChequeType: value.sPaymentType,
              ddBank: value.sBankName,
              nBankAccountNo: value.sAccountNo,
              ddBankKey: ddBankKey.length > 0 ? ddBankKey[0].NAME_OF_BANK : "",
              nBankKey: ddBankKey.length > 0 ? value.sBankKey : null,
              sPaymentType: _this.paytovendorForm.get("cbChequeType").value,
              sBankName: _this.paytovendorForm.get("ddBank").value,
              sAccountName: _this.paytovendorForm.get("sBankAccountName").value,
              sAccountNo: _this.paytovendorForm.get("nBankAccountNo").value,
              sBankKey: _this.paytovendorForm.get("nBankKey").value,

              BankOther: value.sBankOther,
              ddApprover1: value.sUserApprove1,
              ddApprover2: value.sUserApprove2,
              sApprove1: value.nApprove1 == null ? null : value.nApprove1,
              sApprove2: value.nApprove2 == null ? null : value.nApprove2,
              cSkipApprove1: value.cSkipApprove1 == "Y" ? true : false,
              GtotalAmountExcluded: _ParseFloatToZero(value.nGrandTotalAmtInvoice),
              GtotalVAT: _ParseFloatToZero(value.nGrandTotalAmtVat),
              GtotalWithholdingTax: _ParseFloatToZero(
                value.nGrandTotalWithholdingTax
              ),
              GtotalAmountOfInvoice: _ParseFloatToZero(
                value.nGrandTotalAmt
              ),
              sChequeNo: value.sChequeNo,
              dChequeDate: new Date(_this.convertTodate(value.dChequeDate)),
              nChequeAmount: _ParseFloatToZero(value.nChequeAmount),
              sComment: value.sComment,
              sCommentSSC: value.sCommentSSC,
            });
            if (i === 0) {
              _this.paytovendorForm.patchValue({
                ddCurrency: value.sCurrency,
                nAmount: _ParseFloatToZero(value.nExcludeVAT),
                nWHTAmount: _ParseFloatToZero(value.nWHTVal),
              });
            }
            _this.sCommentSSC = value.sCommentSSC;
          });
        }
        _this.ArrGL.push(
          new FormGroup({
            sGL: new FormControl("", Validators.required),
            sCostCenter: new FormControl(""),
            sIO: new FormControl(""),
            sProfitCenter: new FormControl("", Validators.required),
            sAmountExcludedVAT: new FormControl("", Validators.required),
            sText: new FormControl("", Validators.required),
            IsDelete: new FormControl(""),
            sInvoiceNo: new FormControl(""),
            nline: new FormControl(""),
          })
        );
        this.System.UnBlockUI();
      } else {
        this.ArrMaster = [];
        this.ArrMaster.push(this.ArrIO);
        this.ArrGL.clear();
        this.Currencys = "THB";

        _this.paytovendorForm.patchValue({
          GtotalVAT: 0,
          GtotalAmountExcluded: 0,
          GtotalAmountOfInvoice: 0,
          GtotalWithholdingTax: 0,
        });
        this._paytovendorForm.ArrGL.reset();
        _this.ArrGL.push(
          new FormGroup({
            sGL: new FormControl("", Validators.required),
            sCostCenter: new FormControl(""),
            sIO: new FormControl(""),
            sProfitCenter: new FormControl("", Validators.required),
            sAmountExcludedVAT: new FormControl("", Validators.required),
            sText: new FormControl("", Validators.required),
            IsDelete: new FormControl(""),
            sInvoiceNo: new FormControl(""),
            nline: new FormControl(""),
          })
        );
        _this.isNew = true;
        _this.ArrInvoice = [];
        let data: any;
        await this.http
          .get(
            this.System.SiteName +
              "api/_Paytovendor/GetRequestNoItem/" +
              sReqID +
              ""
          )
          .toPromise()
          .then((Data) => (data = Data));
        if (data != null) {
          let chunks = data[0].dDueDate.split("/");
          this.toDay =
            data[0].dRequestDate == null
              ? this.BusinessDay.SetToday(this.holidays)
              : new Date(data[0].dRequestDate);
          let dDuedate = new Date(
            chunks[1] + "-" + chunks[0] + "-" + chunks[2]
          );
         
          if (
            (data[0].nStatusID == 1 ||
              data[0].nStatusID == 3 ||
              data[0].nStatusID == 5 ||
              data[0].nStatusID == 7 ||
              data[0].nStatusID == 10) &&
            dDuedate < _this.Settodate
          ) {
            this.maxDate.setDate(this.maxDate.getDate() + 1);
            this.TODAY = this.BusinessDay.SetNextDate(
              this.maxDate,
              this.holidays
            );
            
          }
          if (data[0].cSkipApprove1 == "Y") {
            _this.paytovendorForm.get("ddApprover1").disable();
          } else {
            _this.paytovendorForm.get("ddApprover1").enable();
          }
          _this.paytovendorForm.patchValue({
            dDueDate: dDuedate,
            nContactID: data[0].nContactID + "",
            sName: data[0].sName,
            sEmail: data[0].sEmail,
            sUnit: data[0].sUnit,
            sTel: data[0].sTel,
            ntype: data[0].ntype,

            sRequestID: data[0].sRequestID,
            ddApprover1: data[0].sUserApprove1,
            ddApprover2: data[0].sUserApprove2,
            sApprove1: data[0].nApprove1 == null ? null : data[0].nApprove1,
            sApprove2: data[0].nApprove2 == null ? null : data[0].nApprove2,
            cSkipApprove1: data[0].cSkipApprove1 == "Y" ? true : false,
          });
        }
        this.System.UnBlockUI();
      }
    } else {
      this.Currencys = "THB";
      if (!this.isNewRequest) {
        let data: any;
        await _this.http
          .get(
            _this.System.SiteName + "api/ROService/GetRequest/" + sReqID + ""
          )
          .toPromise()
          .then((Data) => (data = Data));
        if (data != null) {
          _this.paytovendorForm.patchValue({
            sRequestID: data[0].sRequestID,
            ntype: data[0].nReqType.toString(),
            sComment: data[0].sComment,
            sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
          });
          _this.sComment = data[0].sComment;
          _this.sCommentSSC = data[0].sRemarkSSC;
          _this.onUserSelect(data[0].sFullName);
        }
      }

      _this.paytovendorForm.patchValue({
        GtotalVAT: 0,
        GtotalAmountExcluded: 0,
        GtotalAmountOfInvoice: 0,
        GtotalWithholdingTax: 0,
      });
    }
    if (!this.isNewRequest) {
      let file: any;
      await this.http
        .get(this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "")
        .toPromise()
        .then((Data) => (file = Data));
      if (file) {
        let arrdata = [];
        if (file.length != 0) {
          file.forEach((f) =>
            arrdata.push({
              nID: f.nFileOrder,
              sPath: f.sPathFile,
              sSystemFileName: f.sSystemFileName,
              sFileName: f.sFileName,
              sSize: +f.sFileSize,
            })
          );
          SetData("dvFile", arrdata);
        }
      }
    }
    let ObjData = {
      sRequestID: sReqID,
      nMenuID: 10,
    };

    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (!this.ResultPermission) {
      this.paytovendorForm.disable();
      this.paytovendorForm.get("GtotalVAT").enable();
      this.paytovendorForm.get("GtotalAmountExcluded").enable();
      this.paytovendorForm.get("GtotalAmountOfInvoice").enable();
      this.paytovendorForm.get("GtotalWithholdingTax").enable();
      this.paytovendorForm.get("sCompName").enable();
    }

    this.System.UnBlockUI();
  }

  OnBlurGCI(event: TypeaheadMatch, _inx, _sType) {
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          if (!event.item.GL_ACCOUNT_NO) {
            Pass = false;
          }
          break;
        case "C":
          let stC = this.paytovendorForm.get("sCostCenter").value;
          let ischeckC = this.ArrCostCenter.filter(
            (f) => f.COST_CENTER == stC || f.name == stC || f.DESCRIPTION == stC
          )[0];
          if (isNullOrUndefined(ischeckC)) {
            Pass = false;
          }
          break;
        case "I":
          let stI = this.paytovendorForm.get("sIO").value;
          let ischeckI = this.ArrMaster[_inx].filter(
            (f) =>
              f.ORDER_NUMBER == stI || f.name == stI || f.DESCRIPTION == stI
          )[0];
          if (isNullOrUndefined(ischeckI)) {
            Pass = false;
          }
          break;
        case "P":
          let stP = this.paytovendorForm.get("sProfitCenter").value;
          let ischeckP = this.ArrProfitCenter.filter(
            (f) =>
              f.sProfitCenterNo == stP || f.name == stP || f.DESCRIPTION == stP
          )[0];
          if (isNullOrUndefined(ischeckP)) {
            Pass = false;
          }
          break;
      }
    } catch (ex) {
      Pass = false;
    }
    if (Pass) {
      this.OnSelectGCI(event, _inx, _sType);
    } else {
      switch (_sType) {
        case "G":
          this.paytovendorForm.patchValue({ sGL: "" });
          break;
        case "C":
          this.paytovendorForm.patchValue({ sCostCenter: "" });
          break;
        case "I":
          this.paytovendorForm.patchValue({ sIO: "" });
          break;
        case "P":
          this.paytovendorForm.patchValue({ sProfitCenter: "" });
          break;
      }
    }
  }
  OnSelectGCI(event, _inx, _sType) {
    switch (_sType) {
      case "G":
        this.paytovendorForm.patchValue({ sGL: event.item.GL_ACCOUNT_NO });
        break;
      case "C":
        this.ArrMaster[_inx] = this.ArrIO;
        this.paytovendorForm.patchValue({
          sCostCenter: event.item.COST_CENTER,
        });
        break;
      case "I":
        this.paytovendorForm.patchValue({ sIO: event.item.ORDER_NUMBER });
        break;
      case "P":
        this.paytovendorForm.patchValue({
          sProfitCenter: event.item.sProfitCenterNo,
        });
        break;
    }
  }

  AddGL() {
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.push(
      new FormGroup({
        sGL: new FormControl("", Validators.required),
        sCostCenter: new FormControl(""),
        sIO: new FormControl(""),
        sProfitCenter: new FormControl("", Validators.required),
        sAmountExcludedVAT: new FormControl("", Validators.required),
        sText: new FormControl("", Validators.required),
        IsDelete: new FormControl(false),
        sInvoiceNo: new FormControl(""),
      })
    );
  }
  DeleteGL(sInvoiceNo, row) {
    let _this = this;

    this.SW.SwAlert.Confirm(
      this.SW.BoxMsg.Title_Confirm,
      this.SW.BoxMsg.Desc_Confirm_Delete,
      function () {
        _this.ArrGL.at(row).patchValue({ IsDelete: true });
        let isnull = !isNullOrUndefined(sInvoiceNo) ? sInvoiceNo : "";
        if (isnull == "") {
          _this.ArrGL.removeAt(row);
        } else {
          let data = _this.ArrInvoice.filter((f) => f.sInvoiceNo == sInvoiceNo)[
            row
          ];
          if (data) {
            data.IsDelete = true;
          }
          let FieldGLValid: string[] = ["sGL", "sAmountExcludedVAT", "sText"];
          for (let i = 0; i < FieldGLValid.length; i++) {
            _this.ArrGL.at(row).get(FieldGLValid[i]).clearValidators();
            _this.ArrGL.at(row).get(FieldGLValid[i]).setValidators([]);
            _this.ArrGL.at(row).get(FieldGLValid[i]).updateValueAndValidity();
          }
        }
      },
      function () {}
    );
  }
  hidBranch() {
    let _this = this;
    this.hBranch = this.paytovendorForm.value.cbOffice == 2 ? false : true;
    if (this.hBranch == false) {
      var code = this.paytovendorForm.get("sBranch").value;
      if (code === "") code = "00000";
      this.paytovendorForm.controls["sBranch"].enable();
      this.paytovendorForm.patchValue({ sBranch: code });
      if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
        this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
          invoice
        ) {
          invoice.cbOffice =
            _this.paytovendorForm.value.cbOffice == 1
              ? 1
              : _this.paytovendorForm.value.cbOffice;
          invoice.nOfficeType =
            _this.paytovendorForm.value.cbOffice == 1
              ? 1
              : _this.paytovendorForm.value.cbOffice;
          invoice.sVendorBranch = code;
        });
      }
    } else {
      this.paytovendorForm.controls["sBranch"].disable();
      this.paytovendorForm.patchValue({ sBranch: "" });
      if (this.ArrInvoice.filter((f) => f.cActive != "N").length > 0) {
        this.ArrInvoice.filter((f) => f.cActive != "N").forEach(function (
          invoice
        ) {
          invoice.cbOffice =
            _this.paytovendorForm.value.cbOffice == 1
              ? 1
              : _this.paytovendorForm.value.cbOffice;
          invoice.nOfficeType =
            _this.paytovendorForm.value.cbOffice == 1
              ? 1
              : _this.paytovendorForm.value.cbOffice;
          invoice.sVendorBranch = "";
        });
      }
    }
  }
  OnSkipApprove1() {
    let _this = this;
    if (_this.paytovendorForm.value["cSkipApprove1"]) {
      _this.paytovendorForm.patchValue({ sApprove1: null });
      _this.paytovendorForm.get("ddApprover1").reset();
      _this.paytovendorForm.get("ddApprover1").disable();
    } else {
      let name1 = _this.DataApprover.filter(
        (f) => f.nUserID == _this.GetApprover.name1ID
      )[0];
      let nUserId = _this.DataApprover.filter(
        (f) => f.nUserID == _this.GetApprover.name1ID
      )[0];
      this.paytovendorForm.patchValue({
        ddApprover1: isNullOrUndefined(name1) == true ? "" : name1.name1,
        sApprove1: isNullOrUndefined(nUserId) == true ? null : nUserId.nUserID,
      });
      this.paytovendorForm.get("ddApprover1").enable();
    }
  }
  Export() {
    const link = document.createElement("a");
    link.target = "_blank";
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sReqID + "")
        .set("nContactID", this.paytovendorForm.get("nContactID").value),
    };
    link.href =
      this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params;
    link.setAttribute("visibility", "hidden");
    link.click();
  }
  Back() {
    this.router.navigate(["/home"]);
  }
  SetForm() {
    let ua = this.System.GetUserStorage();
    this.paytovendorForm = this.formBuilder.group({
      sRequestID: [null],
      sRequestBy: [ua.nUserID],
      nContactID: [ua.nUserID],
      sName: [ua.sFullName, Validators.required],

      sEmail: [
        ua.sEmail,
        Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$"),
      ],
      sUnit: [ua.sUnitName],
      sTel: [ua.sTel],
      dToday: [this.dToday],
      sCompCode: [ua.sCompCode],
      sCompName: [ua.sCompName],
      sBusinessArea: [null],

      ntype: ["90"],
      dDueDate: [null, Validators.required],
      sCopyRequest: [null],
      nCopyRequest: [null],
      sOtherRefNoFIDocNo: [null],
      nVendorCode: [null, Validators.required],
      sTAXID: [null, Validators.required],
      sVendorName: [null, Validators.required],
      cbOffice: [1],
      cbReceiveTypeB2C: [4],
      sBranch: [null],
      sAddress: [null, Validators.required],

      sCountryID: "",
      txtCountryID: "",
      sProvCode: "",
      sProvName: "",
      sAmpCode: "",
      sAmpName: "",
      sTumbonCode: "",
      sTumbonName: "",
      sPostCode: "",
      sPhoneNumber: "",
      sFaxNumber: "",
      sVendorEmail: "",
      sAddressOneTime: "",

      sInvoiceNo: [""],
      nAmount: [null, Validators.required],
      nWHTAmount: ['0.00', Validators.required],
      sInvoiceNo2: [null, Validators.required],
      nAmount2: [null, Validators.required],
      sGL: [null, Validators.required],
      sCostCenter: [null],
      sIO: [null],
      sProfitCenter: [null, Validators.required],

      dInvoiceDate: [new Date(), Validators.required],
      sDescription: [null, Validators.required],
      nTotalAmount: [null],
      ddCurrency: ["THB"],
      nVat: [null],
      ddVatType: ["-1"],
      nTotalAmountInvoice: [null],
      nTotalAmountVat: [null, Validators.required],
      nWHTVal: [null],
      sComment: [null],
      sCommentSSC: [null],

      ArrGL: new FormArray([
        new FormGroup({
          sGL: new FormControl("", Validators.required),
          sCostCenter: new FormControl(""),
          sIO: new FormControl(""),
          sProfitCenter: new FormControl("", Validators.required),
          sAmountExcludedVAT: new FormControl("", Validators.required),
          sText: new FormControl("", Validators.required),
          IsDelete: new FormControl(false),
          sInvoiceNo: new FormControl(""),
          nline: new FormControl(""),
        }),
      ]),

      cbChequeType: ["C"],
      ddBank: ["", Validators.required],
      BankOther: ua.sCompCode == 396 ? ["", Validators.required] : [null],
      sBankAccountName: [null],
      nBankAccountNo: [null, Validators.required],
      nBankKey: [null],
      ddBankKey: [null, Validators.required],

      sChequeNo: [null, Validators.required],
      dChequeDate: [new Date(), Validators.required],
      nChequeAmount: [null, Validators.required],

      GtotalAmountOfInvoice: [null],
      GtotalAmountExcluded: [null],
      GtotalWithholdingTax: [null],
      GtotalVAT: [null],

      ddApprover1: [null, Validators.required],
      sApprove1: [null],
      sApprove2: [null],
      ddApprover2: [null, Validators.required],
      cSkipApprove1: [null],
    });
  }

  CheckPattern(event) {
    const charCode = event.key;
    if (charCode != "Backspace") {
      var regExp = new RegExp("[0-9]", "g");
      if (regExp.test(charCode)) {
        return true;
      } else {
        return false;
      }
    }
  }
  getReqID() {
    let comcode = this.nComcode;
    let width = comcode.toString().length;
    if (width > 0) {
      comcode = new Array(width == 3 ? 0 : 3).join("0") + comcode;
    }
    let dToday = this.datepipe.transform(this.today, "yyMMdd");
    let type = this.paytovendorForm.value.ntype;
    let ReqID: string = comcode + dToday + type;
    return ReqID;
  }

  isFieldValid(_Field: string) {
    return (
      !this.paytovendorForm.get(_Field).valid &&
      this.paytovendorForm.get(_Field).touched
    );
  }
  displayFieldCss(_Field: string) {
    return {
      "has-error": this.isFieldValid(_Field),
      "has-feedback": this.isFieldValid(_Field),
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.paytovendorForm.get("ArrGL") as FormArray;
    return (
      !FromArray.at(_inx).get(_Field).valid &&
      FromArray.at(_inx).get(_Field).touched
    );
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      "has-error": this.isFieldValidTbGl(_Field, _inx),
      "has-feedback": this.isFieldValidTbGl(_Field, _inx),
    };
  }
  async checkDupinBase(Invoice, InvoiceDate) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let chunks = InvoiceDate.split("/");
    let dInvoiceDate = chunks[1] + "-" + chunks[0] + "-" + chunks[2];
    let data = JSON.stringify({ Invoice: Invoice, InvoiceDate: dInvoiceDate, sCompCode: this.nComcode });
    return await this.http
      .post(this.System.SiteName + "api/_Paytovendor/CheckDupinBase", data, {
        headers,
        responseType: "text",
      })
      .toPromise()
      .then((s) => s);
  }

  async EditcheckDupinBase(Invoice, InvoiceDate, sReqid) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let chunks = InvoiceDate.split("/");
    let dInvoiceDate = chunks[1] + "-" + chunks[0] + "-" + chunks[2];
    let data = JSON.stringify({
      Invoice: Invoice,
      InvoiceDate: dInvoiceDate,
      sReqid: sReqid,
      sCompCode: this.nComcode
    });
    return await this.http
      .post(
        this.System.SiteName + "api/_Paytovendor/EditCheckDupinBase",
        data,
        { headers, responseType: "text" }
      )
      .toPromise()
      .then((s) => s);
  }

  numberOnly(event): boolean {
    const charCode = event.key;
    var regExp = new RegExp("[A-Za-z]", "g");
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }
  convertTodate(dDate) {
    if (dDate) {
      let chunks = dDate.split("/");
      return new Date(chunks[1] + "-" + chunks[0] + "-" + chunks[2]);
    }
    return this.TODAY;
  }
  _ConvertToDecimal(sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }

  TypeNoResults(event: boolean): void {
    this.TypeNoResult = event;
    if (event) {
      this.VendorCodemaxLength = 11;
    } else {
      this.VendorCodemaxLength = 50;
    }
  }
  async TypeOnBlur(event) {
    var vendorcode = this.paytovendorForm.get("nVendorCode").value;
    var ischeck = this.ArrVendor.filter(
      (f) => f.CUSTOMER_CODE == vendorcode || f.Vendor == vendorcode
    )[0];

    this.paytovendorForm.patchValue({ nVendorCode: null });
    this.ClearInvoice();
    if (this.TypeNoResult == false && !isNullOrUndefined(ischeck)) {
      this.onVendorSelect(event);
    } else if (this.TypeNoResult == false && isNullOrUndefined(ischeck)) {
      this.paytovendorForm.patchValue({ nVendorCode: null });
      this.ClearInvoice();
    }
  }

  CopyNoResults(event: boolean): void {
    this.CopyNoResult = event;
  }

  CopyOnBlur(item) {
    let sCopyRequest = this.paytovendorForm.get("sCopyRequest").value;
    let ischeck = this.DataRequest.filter(
      (user) => user.sRequestCode == sCopyRequest
    )[0];
    if (this.DataRequest) {
      if (sCopyRequest == "") {
        /*  this.ArrInvoice = [];
          this.ClearInvoice();
          this.CheckInvoice(); */
      } else if (
        sCopyRequest != "" &&
        this.CopyNoResult == false &&
        !isNullOrUndefined(ischeck)
      ) {
        this.onCopyRequestCodeSelect(item);
      }
      if (this.CopyNoResult == true) {
        this.paytovendorForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null,
        });
        /*   this.ArrInvoice = [];
           this.ClearInvoice();
           this.CheckInvoice();*/
      } else if (this.CopyNoResult == false && isNullOrUndefined(ischeck)) {
        this.paytovendorForm.patchValue({
          sCopyRequest: null,
          nCopyRequest: null,
        });
      }
    }
  }

  GlNoResults(event: boolean, index): void {
    this.GlNoResult[index] = event;
  }

  CostCenterNoResults(event: boolean, index): void {
    this.CostCenterNoResult[index] = event;
  }

  IONoResults(event: boolean, index): void {
    this.IONoResult[index] = event;
  }

  ProfitCenterNoResults(event: boolean, index): void {
    this.ProfitCenterNoResult[index] = event;
  }

  Approver2NoResults(event: boolean): void {
    this.Approve2NoResult = event;
  }

  Approver1NoResults(event: boolean): void {
    this.Approve1NoResult = event;
  }

  CheckInvoice() {
    let _this = this;
    this.ArrInvoicelength = this.ArrInvoice.filter(
      (f) => f.cActive != "N"
    ).length;
    let onetime = [
      "sBranch",
      "cbOffice",
      "txtCountryID",
      "sProvName",
      "sAmpName",
      "sTumbonName",
    ];
    if (this.ArrInvoice.filter((f) => f.cActive != "N").length >= 1) {
      onetime.forEach(function (value) {
        _this.paytovendorForm.controls[value].enable();
      });
      this.paytovendorForm.controls["dDueDate"].enable();
      this.paytovendorForm.controls["ddCurrency"].enable();
      this.paytovendorForm.controls["ntype"].enable();

      this.ClearInvoice();
    }
    _this.calGrand();
  }

  OnBankOther(value) {
    if (value.target.value == "Other, please specify") {
      this.hidbankother = false;
      this.paytovendorForm.controls["BankOther"].enable();
      this.paytovendorForm.controls["BankOther"].markAsTouched({
        onlySelf: true,
      });
      this.paytovendorForm.controls["BankOther"].setValidators([
        Validators.required,
      ]);
      this.paytovendorForm.controls["BankOther"].updateValueAndValidity();
    } else {
      this.paytovendorForm.patchValue({ BankOther: null });
      this.hidbankother = true;
      this.paytovendorForm.controls["BankOther"].clearValidators();
      this.paytovendorForm.controls["BankOther"].markAsUntouched({
        onlySelf: true,
      });
      this.paytovendorForm.controls["BankOther"].setValidators([]);
      this.paytovendorForm.controls["BankOther"].setErrors(null);
      this.paytovendorForm.controls["BankOther"].updateValueAndValidity();
      this.paytovendorForm.controls["BankOther"].disable();
    }
  }

  async onBankBranchSelect(event) {
    this.paytovendorForm.patchValue({
      ddBankKey: event.item.NAME_OF_BANK,
      nBankKey: event.item.BANK_KEY,
    });
  }

  BankNoResults(event: boolean): void {
    this.BankNoResult = event;
  }

  BankOnBlur(item) {
    let bank = this.paytovendorForm.get("ddBankKey").value;
    let ischeck = this.DataBankBranch.filter((f) => f.Show == bank);
    if (ischeck.length == 0) {
      ischeck = this.DataBankBranch.filter((f) => f.NAME_OF_BANK == bank);
      if (ischeck.length == 0) {
        ischeck = this.DataBankBranch.filter((f) => f.BANK_KEY == bank);
      }
    }
    if (this.BankNoResult == true) {
      this.paytovendorForm.patchValue({ ddBankKey: null, ddBankKey2: null });
      this.paytovendorForm.controls["ddBankKey2"].disable();
    } else if (this.BankNoResult == false && ischeck.length > 0) {
      this.onBankBranchSelect(item);
    } else if (this.BankNoResult == false && ischeck.length == 0) {
      this.paytovendorForm.patchValue({ ddBankKey: null, ddBankKey2: null });
      this.paytovendorForm.controls["ddBankKey"].enable();
      this.paytovendorForm.controls["ddBankKey2"].disable();
    }
  }

  ClearSubInvoice(mode: number) {
    let _this = this;
    this.isEdit1 = false;
    this.isEdit2 = false;
    let FieldValid: string[] = [
      "sInvoiceNo",
      "sInvoiceNo2",
      "nAmount2",
      "sGL",
      "sProfitCenter",
    ];
    for (let i = 0; i < FieldValid.length; i++) {
      _this.paytovendorForm.get(FieldValid[i]).markAsUntouched();
    }
    if (mode === 1) {
      this.paytovendorForm.patchValue({
        sInvoiceNo: "",
      });
    } else {
      this.paytovendorForm.patchValue({
        sInvoiceNo2: "",
        nAmount2: "",
        sGL: "",
        sCostCenter: "",
        sIO: "",
        sProfitCenter: "",
      });
    }

    this.ArrMaster = [];
    this.ArrMaster.push(this.ArrIO);
    this.ArrGL.clear();
    this._paytovendorForm.ArrGL.reset();
    this.ArrGL.push(
      new FormGroup({
        sGL: new FormControl("", Validators.required),
        sCostCenter: new FormControl(""),
        sIO: new FormControl(""),
        sProfitCenter: new FormControl("", Validators.required),
        sAmountExcludedVAT: new FormControl("", Validators.required),
        sText: new FormControl("", Validators.required),
        IsDelete: new FormControl(false),
        sInvoiceNo: new FormControl(""),
        nline: new FormControl(""),
      })
    );
  }

  Check2Digit(sValue) {
    let Result: number = 0;
    if (sValue) {
      let sValueNoComma = (sValue + "").replace(/,/g, "");
      let sValueNoComma2 = Math.round(parseFloat(sValueNoComma) * 100) / 100;
      Result = Number(sValueNoComma2.toFixed(2));
    }
    return Result;
  }
}

function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}

function _ParseFloatToZero(sVal) {
  let Result: any = 0;
  if (sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");
    Result = parseFloat(NoComma);
  }
  return Result;
}
